export const licenses = [
  {
    id: 'lic-1',
    userId: 'user-2',
    orderId: 'order-1',
    productId: 'prod-1',
    planId: 'plan-1b',
    productName: 'Motion Grid Pro',
    planName: 'Agency',
    licenseKeyLast4: '9A2B',
    status: 'active' as const,
    siteLimit: 25,
    activatedSites: 3,
    expiresAt: null,
    gracePeriodEndsAt: null,
    createdAt: '2025-03-10',
  },
  {
    id: 'lic-2',
    userId: 'user-2',
    orderId: 'order-2',
    productId: 'prod-4',
    planId: 'plan-4a',
    productName: 'Elementor Starter Kit',
    planName: 'Starter',
    licenseKeyLast4: '7C4D',
    status: 'active' as const,
    siteLimit: 1,
    activatedSites: 1,
    expiresAt: null,
    gracePeriodEndsAt: null,
    createdAt: '2025-03-15',
  },
  {
    id: 'lic-3',
    userId: 'user-3',
    orderId: 'order-3',
    productId: 'prod-2',
    planId: 'plan-2b',
    productName: 'Loop Grid Filters',
    planName: 'Multi',
    licenseKeyLast4: '3E8F',
    status: 'active' as const,
    siteLimit: 10,
    activatedSites: 5,
    expiresAt: null,
    gracePeriodEndsAt: null,
    createdAt: '2025-04-01',
  },
  {
    id: 'lic-4',
    userId: 'user-4',
    orderId: 'order-5',
    productId: 'prod-7',
    planId: 'plan-7a',
    productName: 'Motion Icon Library',
    planName: 'Standard',
    licenseKeyLast4: '5G1H',
    status: 'active' as const,
    siteLimit: 999,
    activatedSites: 12,
    expiresAt: null,
    gracePeriodEndsAt: null,
    createdAt: '2025-04-05',
  },
  {
    id: 'lic-5',
    userId: 'user-5',
    orderId: 'order-6',
    productId: 'prod-3',
    planId: 'plan-3a',
    productName: 'Motion Portfolio Theme',
    planName: 'Standard',
    licenseKeyLast4: '2I6J',
    status: 'expired' as const,
    siteLimit: 1,
    activatedSites: 0,
    expiresAt: '2025-04-12',
    gracePeriodEndsAt: null,
    createdAt: '2025-04-12',
  },
];
